import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Deletes a specific Driver Group
 * @param id The ID of the Driver Group being requested for deletion
 * @returns A Data Object Indicating Success
 */
export function deleteDriverGroups(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${fleetEnvironment.resolve(this).driverGroupsUrl}/${id}`, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
      })
    )
  );
}
